import React, { useLayoutEffect, useRef } from 'react';
import { css } from '@emotion/core';
import $ from 'jquery';

function FontScaleDiv({
    content = '',
    placeholder = '',
    style = {},
    maxFontSize = 24,
    minFontSize = 16,
    lineHeight = 1.2,
    rowLimit = 2
}) {
    const inputRef = useRef(null);
    const maxHeight = maxFontSize * lineHeight * rowLimit;
    const showPlaceholder = !String(content).trim();

    useLayoutEffect(() => {
        const e = inputRef.current;
        if (e) {
            let elem = $(e);
            elem.css('font-size', `${maxFontSize}px`);
            while (e.scrollHeight > maxHeight && elem.css('font-size') > `${minFontSize}px`) {
                elem.css('font-size', '-=1');
            }
        }
    }, [maxHeight, maxFontSize, minFontSize, content]);

    return (
        <div
            ref={inputRef}
            css={[
                containerStyle,
                css(style),
                getCustomStyle({ lineHeight, maxFontSize, maxHeight })
            ]}
        >
            {showPlaceholder ? placeholder : content}
        </div>
    );
}

export default FontScaleDiv;

const containerStyle = css`
    overflow: hidden;
    overflow-wrap: break-word;
    letter-spacing: normal;
    white-space: pre-wrap;
    font-weight: 500;
`;

const getCustomStyle = ({ lineHeight, maxFontSize, maxHeight }) => css`
    max-height: ${maxHeight}px;
    font-size: ${maxFontSize}px;
    line-height: ${lineHeight};
`;
